import React, { useEffect, useState } from "react";
import SofIcon from "../common/Icons";
import { Account } from "react-aad-msal";
import { connect } from "react-redux";
import { Delete } from "../../api/apiUtils";
import { SofView } from "../../models";
import { DefaultButton, mergeStyleSets, PrimaryButton } from "office-ui-fabric-react";
import { mergeStyles, FontIcon } from "@fluentui/react";
import { State } from "../../store";
import { useHistory } from "react-router";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as SofViewStore from "../../store/SofViewStore";

type Props = GeneralStore.GeneralState &
  LineHandlingStore.LineHandlingState &
  typeof ActivityLogStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  typeof SofViewStore.actionCreators;

const buttonBase = mergeStyles({
  padding: "9px 10px",
  fontSize: 16,
  fontWeight: 500,
  height: 42,
  border: "none",
  color: "#4c4c4c",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0",
    },
  },
});
const buttonIcon = mergeStyles({
  padding: "9px",
  fontSize: 16,
  fontWeight: 500,
  height: 40,
  width: 40,
  justifyContent: "center",
  border: "1px solid var(--grey-200)",
  borderRadius: "2px",
  display: "flex",
  alignItems: "center",
  color: "#4c4c4c",
  background: "var(--grey-050)",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0",
    },
  },
});
const classes = mergeStyleSets({
  header: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 24,
    color: "#00447E",
    textAlign: "left",
  },
  body: {
    textAlign: "left",
    margin: "18px 0 38px 0",
  },
  footer: {
    textAlign: "right",
  },
  button: [
    buttonBase,
    {
      padding: "10px 16.5px",
      height: "auto",
    },
  ],
  modalButton: [
    buttonBase,
    {
      padding: "9px 20px",
    },
  ],
  primaryButton: [
    buttonBase,
    {
      backgroundColor: "#009FDF",
      color: "#FFFFFF",
      padding: "9px 20px",
    },
  ],
});

const DeleteActivitiesModal: React.FC<Props> = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [lineHandlingNo, setLineHandlingNo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  const deleteActivitiesClick = () => {
    setShowModal(true);
  };

  const deleteActivities = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      if (lineHandlingNo === undefined) return;
      const response = await Delete(
        `api/v1.5/linehandling/${lineHandlingNo}/activities`
      );
      setShowModal(false);
      setIsLoading(false);

      props.getActivityLogs(lineHandlingNo, () => {
        props.getLineHandling(lineHandlingNo, "", false, false, () => {
          let previousPage = `?lineHandling=${lineHandlingNo}`;
          props.setSofView(SofView.LineHandling);
          if (history.location.search !== previousPage) {
            history.push(`/sof${previousPage}`);
          }
        });
      });
    } catch (err) {}
  };

  useEffect(() => {
    if (props.lineHandling.result) {
      setLineHandlingNo(props.lineHandling.result.lineHandlingNo);
    }
  }, [props.lineHandling]);

  return (
    <>
      {props.isMarineEditActivityAllowed && (
        <button
          id="btn-undo"
          className={buttonIcon}
          onClick={deleteActivitiesClick}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.589021 0.716021L0.646021 0.646021C0.728877 0.563346 0.838112 0.512359 0.954695 0.501944C1.07128 0.491528 1.18782 0.522343 1.28402 0.589021L1.35402 0.646021L6.00002 5.29302L10.646 0.646021C10.7399 0.552134 10.8672 0.49939 11 0.49939C11.1328 0.49939 11.2601 0.552134 11.354 0.646021C11.4479 0.739908 11.5007 0.867245 11.5007 1.00002C11.5007 1.1328 11.4479 1.26013 11.354 1.35402L6.70702 6.00002L11.354 10.646C11.4367 10.7289 11.4877 10.8381 11.4981 10.9547C11.5085 11.0713 11.4777 11.1878 11.411 11.284L11.354 11.354C11.2712 11.4367 11.1619 11.4877 11.0453 11.4981C10.9288 11.5085 10.8122 11.4777 10.716 11.411L10.646 11.354L6.00002 6.70702L1.35402 11.354C1.26013 11.4479 1.1328 11.5007 1.00002 11.5007C0.867245 11.5007 0.739908 11.4479 0.646021 11.354C0.552134 11.2601 0.49939 11.1328 0.49939 11C0.49939 10.8672 0.552134 10.7399 0.646021 10.646L5.29302 6.00002L0.646021 1.35402C0.563346 1.27117 0.512359 1.16193 0.501944 1.04535C0.491528 0.928764 0.522343 0.81222 0.589021 0.716021Z"
              fill="#4C4C4C"
            />
          </svg>
        </button>
      )}
      {showModal && (
        <div className="modal-bg">
          <div className="modal-right" style={{ width: 400 }}>
            <form>
              <div className={classes.header}>Delete Activities</div>
              <div className={classes.body}>
                <span>
                  You are about to delete all activities. Do you want to
                  proceed?
                </span>
              </div>
                          <div className={classes.footer}>

                              <PrimaryButton
                                  id="btn-submit-undo"
                                  type="submit" 
                                  onClick={deleteActivities}
                                  disabled={isLoading}
                                  text="Proceed"
                              />
                {/*<button*/}
                {/*  id="btn-submit-undo"*/}
                {/*  className={`${classes.primaryButton} btn-prim`}*/}
                {/*  type="submit"*/}
                {/*  onClick={deleteActivities}*/}
                {/*  disabled={isLoading}*/}
                {/*>*/}
                {/*  Proceed*/}
                {/*</button>*/}
                              &nbsp;
                              <DefaultButton
                                  id="btn-cancel-undo"
                                  onClick={() => setShowModal(false)}
                                  disabled={isLoading}
                                  text="Cancel"
                              />
                {/*<button*/}
                {/*  id="btn-cancel-undo"*/}
                {/*  className={`${classes.modalButton} btn-def`}*/}
                {/*  type="button"*/}
                {/*  onClick={() => setShowModal(false)}*/}
                {/*  disabled={isLoading}*/}
                {/*>*/}
                {/*  Cancel*/}
                {/*</button>*/}
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default connect(
  (state: State) => ({
    ...state.general,
    ...state.lineHandling,
  }),
  {
    ...ActivityLogStore.actionCreators,
    ...LineHandlingStore.actionCreators,
    ...SofViewStore.actionCreators,
  }
)(DeleteActivitiesModal as any);
